import produce from 'immer';
import { ActionDiv } from '../../containers/Person/Finance/routes/Invoices/routes/Detail/Detail.style';
import { downloadFile } from '../../library/helpers/utility';
import * as CONSTANTS from './constants';

const initialState = {
  jobs: [],
  w9documentList: [],
  invoicesDocumentList: [],
  proofPaymentsList: [],
  download_all: {
    loading: false,
    error: null
  }
};

const companyDocumentReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CONSTANTS.FETCH_COMPANY_JOB_REQUEST:
        draft.jobs = [];
        break;

      case CONSTANTS.FETCH_COMPANY_JOB_SUCCESS:
        draft.jobs = action.data || [];
        break;

      case CONSTANTS.FETCH_COMPANY_JOB_FAIL:
        draft.jobs = [];
        break;

      case CONSTANTS.FETCH_COMPANY_JOB_INVOICE_DOCUMENT_REQUEST:
        draft.invoicesDocumentList = [];
        break;

      case CONSTANTS.FETCH_COMPANY_JOB_INVOICE_DOCUMENT_SUCCESS:
        draft.invoicesDocumentList = action.data || [];
        break;

      case CONSTANTS.FETCH_COMPANY_JOB_INVOICE_DOCUMENT_FAIL:
        draft.invoicesDocumentList = [];
        break;

      case CONSTANTS.FETCH_COMPANY_JOB_PROOF_OF_PAYMENT_DOCUMENT_REQUEST:
        draft.proofPaymentsList = [];
        break;

      case CONSTANTS.FETCH_COMPANY_JOB_PROOF_OF_PAYMENT_DOCUMENT_SUCCESS:
        draft.proofPaymentsList = action.data || [];
        break;

      case CONSTANTS.FETCH_COMPANY_JOB_PROOF_OF_PAYMENT_DOCUMENT_FAIL:
        draft.proofPaymentsList = [];
        break;

      case CONSTANTS.FETCH_COMPANY_JOB_W9_DOCUMENT_REQUEST:
        draft.w9documentList = [];
        break;
      case CONSTANTS.FETCH_COMPANY_JOB_W9_DOCUMENT_SUCCESS:
        draft.w9documentList = action.data || [];
        break;
      case CONSTANTS.FETCH_COMPANY_JOB_W9_DOCUMENT_FAIL:
        draft.w9documentList = [];
        break;

      case CONSTANTS.FETCH_DOWNLOAD_ALL_AS_ZIP_REQUEST:
        draft.download_all = {
          loading: true,
          error: null
        };
        break;
      case CONSTANTS.FETCH_DOWNLOAD_ALL_AS_ZIP_SUCCESS:
        draft.download_all = {
          loading: false,
          error: null
        };
        downloadFile(action.data, `${action.title}_proof_of_payments_invoices_and_w9s.zip`);
        break;
      case CONSTANTS.FETCH_DOWNLOAD_ALL_AS_ZIP_FAIL:
        draft.download_all = {
          loading: false,
          error: action.error
        };
        break;
      case CONSTANTS.FETCH_DOWNLOAD_ALL_INVOICE_AS_ZIP_SUCCESS:
        downloadFile(action.data, `${action.title}_invoices.zip`);
        break;
      case CONSTANTS.FETCH_DOWNLOAD_ALL_W9_AS_ZIP_SUCCESS:
        downloadFile(action.data, `${action.title}_w9s.zip`);
        break;
      case CONSTANTS.FETCH_DOWNLOAD_ALL_PROOF_OF_PAYMENT_AS_ZIP_SUCCESS:
        downloadFile(action.data, `${action.title}_proof_of_payments.zip`);
        break;
      case CONSTANTS.FETCH_DOWNLOAD_INVOICE_SUCCESS:
        downloadFile(action.data, `${action.title}`);
        break;
      case CONSTANTS.FETCH_DOWNLOAD_PROOF_OF_PAYMENT_SUCCESS:
        downloadFile(action.data, `${action.title}`);
        break;
      case CONSTANTS.FETCH_DOWNLOAD_REPORTS_REQUEST:
        draft.download_all = {
          loading: true,
          error: null
        };
        break;
      case CONSTANTS.FETCH_DOWNLOAD_REPORTS_SUCCESS:
        draft.download_all = {
          loading: false,
          error: null
        };
        downloadFile(action.data, `${action.title}_reports.zip`);
        break;
      case CONSTANTS.FETCH_DOWNLOAD_REPORTS_FAIL:
        draft.download_all = {
          loading: false,
          error: action.error
        };
        break;
      case CONSTANTS.FETCH_DOWNLOAD_ARCHIVE_REQUEST_SUCCESS:
        downloadFile(action.data, action.fileName);
        break;
      default:
        break;
    }
  });

export default companyDocumentReducer;
